<template>
  <div>
    <van-nav-bar title="" left-text="back" left-arrow @click-left="onClickLeft" />
    <div id="app">
    <div class="container white-back">
      <div class="text-center font-36 font-weight-bold ">₹{{ productInfo.all_amount }}</div>
      <div class="text-center margin-bottom-16">
        <img src="https://imgs.hdjfg.com/gift/img/cash-flower.png" style="width:110px" />
      </div>
      <div class="text-center font-20 font-weight-bold margin-bottom-24"> {{ productInfo.status === 0 ? "LOAN  REPAYMENT":"PURCHASES" }} </div>
      <div class="text-center font-16" style="padding:0px 20px">
        {{ productInfo.status === 0 ? "Status" : "due on" }}
      </div>
      <div class="text-center font-16 margin-bottom-16" style="padding:0px 20px;color: #FF5D00;">
        {{ productInfo.status === 0 ? "Cash in review" : productInfo.cycle }}
      </div>

      <span class="font-16 font-weight-bold white  margin-top-30"
        style="padding:12px 21px;background-color: #FF5D00;border-radius: 24px;width: 140px;" @click="back">
        BACK
      </span>
    </div>
  </div>
  </div>

</template>


<script>
import MaskDialog from './Common/MaskDialog.vue'
export default {
  components: {
    MaskDialog,
  },
  data() {
    return {
      productInfo: null,
      token: null,
    }
  },
  computed: {

  },
  created() {
    if (this.$route.query.product_id) { this.product_id = this.$route.query.product_id, this.getMyCashInfo(this.$route.query.product_id) }
    else this.getProductInfo()

  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    back() {
      this.$router.push({
        name: 'index'
      })
    },
    home() {
      this.$router.push({
        name: 'index'
      })
    },
    async getMyCashInfo(product_id) {
      const { data: res } = await this.$http.post('/api/product/myCashInfo', { productId: product_id })
      if (res.code === 0) {
        this.productInfo = res.data
      } else {
        this.$toast(res.msg)
      }
    },
    async getProductInfo() {
      const { data: res } = await this.$http.post('/api/product/myFirstCashInfo')
      if (res.code === 0) {
        this.productInfo = res.data
      } else {
        this.$toast(res.msg)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#app {
  background: #FFA775;
  min-height: 100vh;
  padding: 91px 18px 40px 18px;
  box-sizing: border-box;

  .container {
    padding: 34px 20px 40px 20px;
    border-radius: 14px;
    text-align: center;
    box-sizing: border-box;

    .progress-bar-box {
      height: 12px;
      background: #FFF2EB;
      border-radius: 7px;

      .progress-bar-content {
        background: #FF5D00;
        border-radius: 7px;
        height: 12px;
      }
    }

    .common-day {
      padding: 10px 25px;
      font-size: 16px;
      line-height: 18px;
      height: 18px;
      background: #F6F6F6;
      border-radius: 19px;
    }

    .apply {
      padding: 12px 58px;
      border-radius: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
      font-family: HelveticaNeue-Bold, HelveticaNeue;
      width: 87px;
    }
  }

}
</style>
